import React from 'react';
import { Divider, Icon, Label } from 'semantic-ui-react'

export const AuthMenuItem = React.memo(({ title, iconName, instanceCount, callBackonClick, showDivider = false }) => {
  // console.log('AuthMenuItem rendered', title);
  // return <button onClick={onClick}>Click me</button>;

  const displayItem = () => {
    let instanceCntHtml = instanceCount !== "" ? `(${instanceCount.toString()})` : "";
    if (showDivider) {
      return (
        <div className="dashMenuItem dashMenuItemNoHover" onClick={callBackonClick} >
          {/* <Divider /> */}
          <span className="dashMenuAdminLabel" >{title}</span>
        </div>
      )
    }
    else {
      return (
        <div className="dashMenuItem" onClick={callBackonClick} >
          <div className="dashMenuItemDetail" ><Icon className='dashMenuItemIcon' name={iconName} size="large" /><Label className='dashMenuItemLabel' size="medium" >
            {title}
          </Label>
            {/* <span className="dashMenuItemExtra">{instanceCntHtml}</span> */}
          </div>
        </div>
      )
    }
  }

  return displayItem();

});